<template>

  <div class="help-panels">

    <v-expansion-panels tile>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.whatIsLedgerDex.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.whatIsLedgerDex.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.howDoesTradeWork.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.howDoesTradeWork.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.whatMakeUniqueAsExchange.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.whatMakeUniqueAsExchange.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.howDifferentFromOtherERC20Exchanges.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.howDifferentFromOtherERC20Exchanges.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.howToGetStarted.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.howToGetStarted.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.whatCanBeDoneWithLedgerDex.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.whatCanBeDoneWithLedgerDex.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.about.limitations.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.about.limitations.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>


  </div>


</template>

<script>

export default {
  name: 'AboutHelp',
  props: {
  },
  data () {
    return {
    }
  },
}
</script>


<style scoped>

</style>
